import { render, staticRenderFns } from "./clickToCall.vue?vue&type=template&id=3096fca8&scoped=true"
import script from "./clickToCall.vue?vue&type=script&lang=ts"
export * from "./clickToCall.vue?vue&type=script&lang=ts"
import style0 from "./clickToCall.vue?vue&type=style&index=0&id=3096fca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3096fca8",
  null
  
)

export default component.exports